module.exports = __webpack_public_path__ + "img/G-Pay.27892bbc.jpg";